import { render, staticRenderFns } from "./TwoFASetup.vue?vue&type=template&id=e0d530e8&scoped=true&"
import script from "./TwoFASetup.vue?vue&type=script&lang=js&"
export * from "./TwoFASetup.vue?vue&type=script&lang=js&"
import style0 from "./TwoFASetup.vue?vue&type=style&index=0&id=e0d530e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d530e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBtn,VCardActions,VCardSubtitle,VCardText,VCardTitle,VList,VListItem})
